import { IRoute } from "../interfaces/route.interface";

export const flattenRoutes = (routesArray:Array<IRoute[]>) : IRoute[] => {
    const flattenedRoutes:IRoute[] = [];
    for (let routes of routesArray) {
        for (let route of routes) {
            flattenedRoutes.push(route);
        }
    }
    return flattenedRoutes;
}